import _              from 'underscore';
import { v4 as uuid } from 'uuid';
import { gql }        from 'apollo-boost';

import { BaseStore }                                          from './BaseStore';
import { asType, isResolver, withResolvers }                  from './_apolloUtil';
import { DecisionEngineQueries, StoreQueries, SystemQueries } from '../queries';
import { AUDIT_RECORD_ACTIONS }                               from '../constants/SystemRecordEnums';

@withResolvers
export class GeneralStore extends BaseStore {

	static storeKey      = 'generalStore';
	static storeTypename = 'GeneralStore';
	static typeDefs      = `
	type GeneralStore {
		nothing: String
		auditEntries: [ AuditEntry ]
	  }
	  
    type AuditEntry{
        id: string!
		accountId: string!
		timestampUtc: string!
		auditType: string!
		auditData: string!
		entityId: string!
		entityLabel: string!
		entityType: string!
    }`;

	static state = asType( GeneralStore.storeTypename, {
		nothing:          null,
		auditEntries:     [
			asType( 'AuditEntry', {
				id:           uuid(),
				accountId:    'ee9ee817-41c1-442e-82e1-f23fcac03080', // it me.
				timestampUtc: '2021-07-02T14:54:16.066Z',
				auditType:    'SubObjectiveUpdated',
				auditData:    JSON.stringify( {
					Name:        {
						Type:     AUDIT_RECORD_ACTIONS.CHANGE,
						OldValue: {
							Value:    'Comms plan',
							Readable: 'Comms plan'
						},
						NewValue: {
							Value:    'Cross-stakeholder communication plan',
							Readable: 'Cross-stakeholder communication plan'
						}
					},
					Subcategory: {
						Type:     AUDIT_RECORD_ACTIONS.CHANGE,
						OldValue: {
							Value:    'f54ba1c9-f885-4117-9482-fa8e01b85433',
							Readable: 'Regulatory Strategy and Systems'
						},
						NewValue: {
							Value:    '930582ed-74b7-45e4-81d7-97e396230e2b',
							Readable: 'Corporate Communications'
						}
					},
					Criteria:    [
						{
							Type:     AUDIT_RECORD_ACTIONS.CHANGE,
							OldValue: {
								Value:    { id: 'e87d06e5-2c2f-42b4-b10e-1cc551cfa4c6', conditionType: 'EQUALTO', value: 'false' },
								Readable: 'When "Stakeholder communications plan" is "false"'
							},
							NewValue: {
								Value:    { id: 'e87d06e5-2c2f-42b4-b10e-1cc551cfa4c6', conditionType: 'EQUALTO not', value: 'true' },
								Readable: 'When "Stakeholder communications plan" is not "false"'
							}
						}, {
							Type:     AUDIT_RECORD_ACTIONS.ADD,
							Value:    { id: 'e87d06e5-2c2f-42b4-b10e-1cc551cfa4c6', conditionType: 'EQUALTO', value: 'true' },
							Readable: 'When "Stakeholder communications plan" is not "true"'
						}, {
							Type:     AUDIT_RECORD_ACTIONS.REMOVE,
							Value:    { id: 'e87d06e5-2c2f-42b4-b10e-1cc551cfa4c6', conditionType: 'EQUALTO', value: 'true' },
							Readable: 'When "Stakeholder communications plan" is "true"'
						}
					]
				} ),
				entityId:     '516adac6-99cd-40ae-b730-e773f58c75db',
				entityLabel:  'Cross-stakeholder communication plan',
				entityType:   'SubObjective',
			} ),

			asType( 'AuditEntry', {
				id:           uuid(),
				accountId:    '99931a08-5ba9-4c10-a7a4-d5a818632021', // it them.
				timestampUtc: '2021-06-08T08:32:16.066Z',
				auditType:    'SubObjectiveUpdated',
				auditData:    JSON.stringify( {
					ProjectTimingMilestone: {
						Type:     AUDIT_RECORD_ACTIONS.CHANGE,
						OldValue: {
							Value:    'P2TRIALDATA',
							Readable: 'P2TRIALDATA'
						},
						NewValue: {
							Value:    'INVESTIGATIONALNEWDRUGAPPLICATIONFILING',
							Readable: 'INVESTIGATIONALNEWDRUGAPPLICATIONFILING'
						}
					}
				} ),
				entityId:     'a007f68b-4851-40c2-91c6-700498026952',
				entityLabel:  'Clinical talking points and FAQs',
				entityType:   'SubObjective',
			} ),

			asType( 'AuditEntry', {
				id:           uuid(),
				accountId:    'ee9ee817-41c1-442e-82e1-f23fcac03080', // it me.
				timestampUtc: '2021-03-05T08:21:16.066Z',
				auditType:    'SubObjectiveUpdated',
				auditData:    JSON.stringify( {
					Name: {
						Type:     AUDIT_RECORD_ACTIONS.CHANGE,
						OldValue: { Value: "Liason Engagement Contracts", Readable: 'Liason Engagement Contracts' },
						NewValue: { Value: "Liason Engagement", Readable: 'Liason Engagement' }
					}
				} ),
				entityId:     '5ee58dcf-11d5-42e3-a872-7f0e060d32aa',
				entityLabel:  'Liason Engagement',
				entityType:   'SubObjective',
			} ),

			asType( 'AuditEntry', {
				id:           uuid(),
				accountId:    'ee9ee817-41c1-442e-82e1-f23fcac03080', // it me.
				timestampUtc: '2021-06-28T10:19:16.066Z',
				auditType:    'SubObjectiveUpdated',
				auditData:    JSON.stringify( {
					ordinal:                {
						Type:     AUDIT_RECORD_ACTIONS.CHANGE,
						OldValue: { Value: 0, Readable: '0' },
						NewValue: { Value: 4, Readable: '4' }
					},
					targetIntakeQuestionId: {
						Type:     AUDIT_RECORD_ACTIONS.CHANGE,
						OldValue: { Value: "214cf1f5-3d74-44f9-b873-e03942f4e2f6", Readable: 'Organizational Stage' },
						NewValue: { Value: "d96cef45-2fb4-47b4-844b-59a22b66c6b7", Readable: 'Commercial Stage' }
					},
				} ),
				entityId:     '5ee58dcf-11d5-42e3-a872-7f0e060d32aa',
				entityLabel:  'Liason Engagement',
				entityType:   'SubObjective',
			} ),

			asType( 'AuditEntry', {
				id:           uuid(),
				accountId:    'ee9ee817-41c1-442e-82e1-f23fcac03080', // it me.
				timestampUtc: '2021-02-14T09:47:16.066Z',
				auditType:    'SubObjectiveAdded',
				auditData:    JSON.stringify( {
					applicableStartYear:                {
						Type:     AUDIT_RECORD_ACTIONS.ADD,
						OldValue: { Value: null, Readable: '' },
						NewValue: { Value: 3, Readable: '-3 Years to Launch' }
					},
					conditions:                         {
						Type:     AUDIT_RECORD_ACTIONS.ADD,
						OldValue: { Value: null, Readable: '' },
						NewValue: {
							Value:    [
								{
									conditionType: "EQUALTO",
									id:            "c23eea31-4e93-418a-8e05-dc5d647722ad",
									value:         "a2a7b718-92ea-43be-8aab-8cc56da8de04",
								}
							],
							Readable: 'When "Commercial stage" is "Pre-Commercial"'
						}
					},
					description:                        {
						Type:     AUDIT_RECORD_ACTIONS.ADD,
						OldValue: { Value: null, Readable: '' },
						NewValue: { Value: '', Readable: '' }
					},
					displayName:                        {
						Type:     AUDIT_RECORD_ACTIONS.ADD,
						OldValue: { Value: null, Readable: '' },
						NewValue: { Value: "Advocate / Liason Engagement Guidelines", Readable: 'Advocate / Liason Engagement Guidelines' }
					},
					id:                                 {
						Type:     AUDIT_RECORD_ACTIONS.ADD,
						OldValue: { Value: null, Readable: '' },
						NewValue: { Value: "5ee58dcf-11d5-42e3-a872-7f0e060d32aa", Readable: '5ee58dcf-11d5-42e3-a872-7f0e060d32aa' }
					},
					name:                               {
						Type:     AUDIT_RECORD_ACTIONS.ADD,
						OldValue: { Value: null, Readable: '' },
						NewValue: { Value: "Liason Engagement", Readable: 'Liason Engagement' }
					},
					objectiveId:                        {
						Type:     AUDIT_RECORD_ACTIONS.ADD,
						OldValue: { Value: null, Readable: '' },
						NewValue: { Value: "62be0e5b-de94-49e4-8a1f-0c28ece85865", Readable: '62be0e5b-de94-49e4-8a1f-0c28ece85865' }
					},
					projectTimingMilestone:             {
						Type:     AUDIT_RECORD_ACTIONS.ADD,
						OldValue: { Value: null, Readable: '' },
						NewValue: { Value: "INVESTIGATIONALNEWDRUGAPPLICATIONFILING", Readable: 'INVESTIGATIONALNEWDRUGAPPLICATIONFILING' }
					},
					ordinal:                            {
						Type:     AUDIT_RECORD_ACTIONS.ADD,
						OldValue: { Value: null, Readable: '' },
						NewValue: { Value: 0, Readable: '0' }
					},
					projectTimingMilestoneOffsetMonths: {
						Type:     AUDIT_RECORD_ACTIONS.ADD,
						OldValue: { Value: null, Readable: '' },
						NewValue: { Value: 2, Readable: '2' }
					},
					subCategoryId:                      {
						Type:     AUDIT_RECORD_ACTIONS.ADD,
						OldValue: { Value: null, Readable: '' },
						NewValue: { Value: "930582ed-74b7-45e4-81d7-97e396230e2b", Readable: 'Corporate Communications' }
					},
					targetIntakeQuestionId:             {
						Type:     AUDIT_RECORD_ACTIONS.ADD,
						OldValue: { Value: null, Readable: '' },
						NewValue: { Value: "d96cef45-2fb4-47b4-844b-59a22b66c6b7", Readable: 'Commercial Stage' }
					},
				} ),
				entityId:     '5ee58dcf-11d5-42e3-a872-7f0e060d32aa',
				entityLabel:  'Liason Engagement',
				entityType:   'SubObjective',
			} ),

			asType( 'AuditEntry', {
				id:           uuid(),
				accountId:    '75f990a2-7c55-4ddc-9dd2-34e48561e129', // it them.
				timestampUtc: '2021-06-28T10:57:16.066Z',
				auditType:    'SubObjectiveRemoved',
				auditData:    JSON.stringify( {
					Entity: {
						Type:     AUDIT_RECORD_ACTIONS.REMOVE,
						OldValue: { Value: null, Readable: '' },
						NewValue: { Value: null, Readable: 'Activities moved to "Liason Engagement"' }
					}
				} ),
				entityId:     uuid(),
				entityLabel:  'Education Curriculum Drafted',
				entityType:   'SubObjective',
			} ),

			asType( 'AuditEntry', {
				id:           uuid(),
				accountId:    'ee9ee817-41c1-442e-82e1-f23fcac03080', // it me.
				timestampUtc: '2020-10-21T10:19:16.066Z',
				auditType:    'SubObjectiveUpdated',
				auditData:    JSON.stringify( {
					ordinal:                {
						Type:     AUDIT_RECORD_ACTIONS.CHANGE,
						OldValue: { Value: 2, Readable: '2' },
						NewValue: { Value: 0, Readable: '0' }
					}
				} ),
				entityId:     '5ee58dcf-11d5-42e3-a872-7f0e060d32aa',
				entityLabel:  'Liason Engagement',
				entityType:   'SubObjective',
			} ),

			asType( 'AuditEntry', {
				id:           uuid(),
				accountId:    'ee9ee817-41c1-442e-82e1-f23fcac03080', // it me.
				timestampUtc: '2020-09-15T15:13:16.066Z',
				auditType:    'SubObjectiveAdded',
				auditData:    JSON.stringify( {} ),
				entityId:     '5ee58dcf-11d5-42e3-a872-7f0e060d32aa',
				entityLabel:  'Liason Engagement Contracts',
				entityType:   'SubObjective',
			} ),
		],
	} );

	//
	// GENERAL STORE -----------------------------------------*/
	//
	static storeOperation(
		operation,
		{
			stateRetrievalQuery = StoreQueries.queries.EMPTY_QUERY,
			storeProp = null,
			entityType = null,
			store,
			variables: { input },
			apollo:    { client }
		} ){

		if( !storeProp ){
			throw new Error( `No storeProp was defined to operate on.` );
		}

		try{

			let storeResults = GeneralStore.updateState( stateRetrievalQuery, draft => {

				switch( operation ){

					case 'CREATE_COLLECTION_ENTITY':

						draft.generalStore[ storeProp ].push( asType( entityType, input ) );

						break;

					case 'READ_COLLECTION_ENTITY':

						return _.findWhere( draft.generalStore[ storeProp ], { id: input.id } );

					case 'FIND_COLLECTION_ENTITIES':

						return _.chain( draft.generalStore[ storeProp ] )
						        .filter( input.where )
						        .sortBy( input.order )
						        .value();

					case 'UPDATE_COLLECTION_ENTITY':

						let index = _.findIndex( draft.generalStore[ storeProp ], item => ( item.id === input.id ) );

						if( index !== -1 ){
							draft.generalStore[ storeProp ][ index ] = asType( entityType, input );
						}

						break;

					case 'DELETE_COLLECTION_ENTITY':

						draft.generalStore[ storeProp ] = _.reject( draft.generalStore[ storeProp ], { id: input.id } );

						break;
				}

			}, client );

			console.log( `🔵 [ ${ entityType } ] : ${ operation }` );
			console.log( storeResults );

			return storeResults;

		} catch( e ) {

			console.error( e );
		}
	}

	@isResolver( 'Mutation' )
	static noop( store, variables, apollo ){}

	//
	// STORE ENTITIES -----------------------------------------*/
	//
	static stateRetrievalQueries = {
		AUDIT_ENTRIES: gql`query { generalStore @client { auditEntries { ${ SystemQueries.fragments.AUDIT_RECORDS.SOURCE_QUERY_RETURN } } } }`,
	};

	@isResolver( 'Query' )
	static auditEntries( store, { where = ( item ) => true, order = ( item ) => item.id }, apollo ){

		return GeneralStore.storeOperation( 'FIND_COLLECTION_ENTITIES', {
			stateRetrievalQuery: GeneralStore.stateRetrievalQueries.AUDIT_ENTRIES,
			storeProp:           'auditEntries',
			entityType:          'AuditEntry',
			variables:           {
				input: { where, order }
			},
			store,
			apollo,
		} );
	}

	/*
	@isResolver( 'Mutation' )
	static createEntity( store, variables, apollo ){

		GeneralStore.storeOperation( 'CREATE_COLLECTION_ENTITY', {
			stateRetrievalQuery: GeneralStore.stateRetrievalQueries['SOME_STORE_QUERY'],
			storeProp:           '[SOME_STORE_PROPERTY]',
			entityType:          '[SOME_STORE_TYPE]',
			store, variables, apollo
		} );
	}*/
}
